import React, { useEffect } from 'react';

import { Link } from 'react-router-dom';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';

import TokenService from "../../services/auth/generateToken.service";

import '../../styles/style.scss';
import '../../styles/paymentScreenResponseStyle.scss';

export const PaymentScreenFailure = () => {

    useEffect(() => {
        TokenService.getRefreshToken();
    }, []);

    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col p-0 ms-1 me-1">
                    <NavTopMenu />
                    <div className="container ps-3 pe-3 container-size">
                        <div className="row base-container ">
                        <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                        <span>Pago </span>
                        </div>
                        <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                            <div className="card-message">
                            <div className="d-flex justify-content-center" >
                            <span className="icon-failure-container d-flex align-items-center justify-content-center">
                                <i className="fas fa-times custom-icon-failure"></i>
                            </span>
                            </div>
                            <div className="d-flex justify-content-center mt-3" >
                                <span className="text-message">
                                Error al realizar la operación
                                </span>
                            </div>
                            <div className="d-flex justify-content-center mt-3">
                                <Link to="/operation/payment">
                                <button  
                                    className="btn custom-btn pt-2 pb-2 ps-3 pe-3" 
                                    >
                                    Regresar a pagos
                                </button>
                                </Link>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </>
    )
}